'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Cooker = function (_React$Component) {
    _inherits(Cooker, _React$Component);

    function Cooker() {
        _classCallCheck(this, Cooker);

        return _possibleConstructorReturn(this, (Cooker.__proto__ || Object.getPrototypeOf(Cooker)).apply(this, arguments));
    }

    _createClass(Cooker, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '24', height: '32', viewBox: '0 0 24 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M22.24 26.78V9.938H1.354V26.78c0 .368.304.673.673.673h19.538c.37 0 .673-.303.673-.672zm0-18.19V5.22c0-.368-.305-.673-.674-.673H2.028c-.37 0-.673.303-.673.672v3.37H22.24zm-4.043 15.49v-2.69H5.4v2.694l12.797-.005zm0-7.4L5.4 16.673v3.368h12.797V16.68zm3.37-13.48c1.115 0 2.02.91 2.02 2.02v21.56c0 1.115-.91 2.02-2.02 2.02H2.026c-1.115 0-2.02-.912-2.02-2.02V5.22c0-1.116.91-2.02 2.02-2.02h19.54zM4.724 15.326h14.143c.373 0 .676.302.676.68v8.747c0 .375-.296.68-.676.68H4.725c-.373 0-.676-.303-.676-.68v-8.748c0-.375.295-.68.675-.68zm12.798-2.02c.372 0 .674-.303.674-.675s-.302-.673-.674-.673H5.397c-.372 0-.674.302-.674.674s.302.675.674.675h12.126zM5.397 7.915c.744 0 1.347-.603 1.347-1.347S6.14 5.22 5.397 5.22 4.05 5.825 4.05 6.57s.603 1.346 1.347 1.346zm4.042 0c.743 0 1.346-.603 1.346-1.347S10.183 5.22 9.44 5.22c-.745 0-1.348.603-1.348 1.347s.603 1.346 1.347 1.346zm4.715 0c.744 0 1.347-.603 1.347-1.347S14.9 5.22 14.155 5.22s-1.347.603-1.347 1.347.603 1.346 1.347 1.346zm4.042 0c.744 0 1.347-.603 1.347-1.347S18.94 5.22 18.197 5.22s-1.347.603-1.347 1.347.603 1.346 1.347 1.346z' })
            );
        }
    }]);

    return Cooker;
}(_react2.default.Component);

Cooker.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Cooker;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/cooker.js
// module id = 1092
// module chunks = 0